/*
 * Beatriz Camacho · comportamiento propio sobre Palo Alto 9.2 (un solo archivo, un solo envoltorio de fetch)
 *
 *   1. Loader del monograma (snippets/bc-loader.liquid): solo en acciones ajax.
 *   2. Búsqueda predictiva: pide más resultados; nunca toca la consulta (q).
 *   3. Contador de piezas en el ícono del carrito.
 *   5. Aviso al agregar al carrito (en lugar de abrir el cajón).
 *   4. «Tipo de prenda»: casillas con el mismo nombre BC se marcan juntas (snippets/filter.liquid).
 *   6. Carrusel BC (snippets/bc-carrusel.liquid): flechas, arrastre, barra de avance, bucle infinito y la
 *      entrada suave de la sección «momento».
 *   7. Zona outlet / web: recomendados y vistos solo de la zona de la página.
 *   8. Talla sin elegir: «Agregar al carrito» pide la talla antes de agregar.
 *   9. Póster de los videos de fondo: la misma foto que ya cargó el <img> (una sola descarga).
 *  10. Tope de cantidad en el carrito: el «+» apagado en el stock avisa con el mensaje del theme.
 *
 * Todo lo que mira las peticiones pasa por un único envoltorio de window.fetch, al final del archivo.
 */
(function () {
  'use strict';

  var ORIGEN = window.location.origin;

  function aUrl(recurso) {
    var texto = typeof recurso === 'string' ? recurso : (recurso && recurso.url) || '';
    try {
      return new URL(texto, window.location.href);
    } catch (error) {
      return null;
    }
  }

  /* ------------------------------------------------------------------ 1 · Loader
   * Aparece a los 150 ms, se queda mínimo 400 ms y se retira solo a los 8 s. Una acción puede encadenar
   * peticiones (agregar → /cart/add y luego el carrito renderizado): al terminar se esperan 300 ms antes de
   * ocultar y, si llega otra petición, sigue visible. Así se ve una sola vez por acción.
   * Aparece con: /cart/add|change|update, section_id=api-cart-items|api-quickview, filtros y orden de
   * colección o búsqueda. No aparece con: carga de página, predictiva, scroll, recomendaciones.
   */
  var loader = (function () {
    var el = document.getElementById('BcLoader');
    var RETARDO = 150, MINIMO = 400, TOPE = 8000, GRACIA = 300;
    var pendientes = 0, generacion = 0, visibleDesde = 0;
    var tMostrar = null, tOcultar = null, tTope = null;

    function visible() { return !!el && el.classList.contains('is-visible'); }

    function mostrar() {
      clearTimeout(tOcultar);
      el.classList.add('is-visible');
      visibleDesde = Date.now();
      clearTimeout(tTope);
      tTope = setTimeout(reiniciar, TOPE);
    }

    function ocultar() {
      clearTimeout(tMostrar);
      clearTimeout(tTope);
      el.classList.remove('is-visible');
    }

    // Tope de seguridad: las peticiones que terminen después ya no cuentan (otra generación)
    function reiniciar() {
      pendientes = 0;
      generacion += 1;
      ocultar();
    }

    function esAccion(url) {
      if (!el || !url || url.origin !== ORIGEN) return false;
      var ruta = url.pathname;
      var seccion = url.searchParams.get('section_id') || '';
      if (/\/search\/suggest/.test(ruta) || /\/recommendations\//.test(ruta)) return false;
      if (/\/cart\/(add|change|update)(\.js)?$/.test(ruta)) return true;
      if (seccion === 'api-cart-items' || seccion === 'api-quickview') return true;
      return !!seccion && seccion !== 'api-product-grid-item' && seccion !== 'api-predictive-search' &&
        (/\/collections\//.test(ruta) || /\/search$/.test(ruta));
    }

    function empezar() {
      pendientes += 1;
      if (visible()) {
        clearTimeout(tOcultar);
      } else if (pendientes === 1) {
        clearTimeout(tMostrar);
        tMostrar = setTimeout(mostrar, RETARDO);
      }
      return generacion;
    }

    function terminar(gen) {
      if (gen !== generacion) return;
      pendientes = Math.max(0, pendientes - 1);
      if (pendientes > 0) return;
      clearTimeout(tMostrar);
      if (!visible()) return;
      clearTimeout(tOcultar);
      tOcultar = setTimeout(ocultar, Math.max(GRACIA, MINIMO - (Date.now() - visibleDesde)));
    }

    return { esAccion: esAccion, empezar: empezar, terminar: terminar };
  })();

  /* ------------------------------------------------------------------ 2 · Búsqueda predictiva
   * La consulta (q) NUNCA se modifica: ni en formularios, ni en enlaces, ni por redirección, para que
   * GA4, Google Ads, Mailchimp y la analítica de Shopify reciban el término limpio y cada búsqueda cuente
   * una sola vez. El outlet se excluye en Liquid (sections/search.liquid y api-predictive-search.liquid).
   * Aquí solo se piden 10 resultados por tipo en la predictiva, para que al sacar el outlet sobren piezas.
   */
  var busqueda = (function () {
    function reescribir(recurso, url) {
      if (!url || !/\/search\/suggest/.test(url.pathname)) return recurso;
      url.searchParams.set('resources[limit]', '10');
      url.searchParams.set('resources[limit_scope]', 'each');
      return typeof recurso === 'string' ? url.toString() : new Request(url.toString(), recurso);
    }
    return { reescribir: reescribir };
  })();

  /* ------------------------------------------------------------------ 3 · Contador del carrito
   * Palo Alto solo marca el carrito con un punto. Se agrega un número pequeño a los íconos del carrito del
   * header y se actualiza con /cart.js después de cada cambio por ajax.
   */
  var carrito = (function () {
    var toggles = document.querySelectorAll('.site-header .cart__toggle');
    var contadores = [];
    toggles.forEach(function (toggle) {
      if (toggle.querySelector('.navtext')) return; // modo texto del header: no lleva número
      var span = document.createElement('span');
      span.className = 'bc-cart-count';
      span.setAttribute('aria-hidden', 'true');
      toggle.appendChild(span);
      contadores.push(span);
    });

    function pintar(cantidad) {
      contadores.forEach(function (span) {
        span.textContent = cantidad;
        span.hidden = !(cantidad > 0);
      });
    }

    function actualizar() {
      if (!contadores.length) return;
      fetchOriginal.call(window, (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (b) { pintar(b.item_count); })
        .catch(function () { /* se deja el número anterior */ });
    }

    function esCambio(url) {
      return !!url && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
    }

    pintar(window.bcCartCount || 0);
    window.addEventListener('pageshow', function (e) { if (e.persisted) actualizar(); });

    return { esCambio: esCambio, actualizar: actualizar };
  })();

  /* ------------------------------------------------------------------ 4 · «Tipo de prenda»
   * Varios valores de Shopify con el mismo nombre BC se ven como una sola casilla; las ocultas se marcan
   * igual antes de que filters.js lea el formulario (fase de captura).
   */
  function sincronizarCasillas(evento) {
    var casilla = evento.target;
    if (!(casilla instanceof HTMLInputElement) || !casilla.hasAttribute('data-bc-grupo')) return;
    var ambito = casilla.form || casilla.closest('form') || document;
    var grupo = casilla.getAttribute('data-bc-grupo');
    ambito.querySelectorAll('input[data-bc-grupo="' + grupo + '"]').forEach(function (otra) {
      if (otra !== casilla && !otra.disabled) otra.checked = casilla.checked;
    });
  }
  document.addEventListener('input', sincronizarCasillas, true);
  document.addEventListener('change', sincronizarCasillas, true);

  /* «Talla» filtra por disponibilidad: con una talla marcada, el formulario lleva filter.v.availability=1
   * oculto, y Shopify cruza talla y disponibilidad en la misma variante (sin mostrar un filtro de
   * Disponibilidad). Corre en captura, antes de que filters.js lea el formulario.
   */
  function tallaDisponible(evento) {
    var form = evento.target && evento.target.closest && evento.target.closest('[data-collection-filters-form]');
    if (!form) return;
    var hayTalla = !!form.querySelector('input[name^="filter.v.option.talla"]:checked, input[name^="filter.v.option.size"]:checked');
    var oculto = form.querySelector('input[data-bc-disponible]');
    if (hayTalla && !oculto) {
      oculto = document.createElement('input');
      oculto.type = 'hidden';
      oculto.name = 'filter.v.availability';
      oculto.value = '1';
      oculto.setAttribute('data-bc-disponible', '');
      form.appendChild(oculto);
    } else if (!hayTalla && oculto) {
      oculto.remove();
    }
  }
  document.addEventListener('input', tallaDisponible, true);
  document.addEventListener('change', tallaDisponible, true);

  /* Con una talla activa la colección va entera en una sola página (sections/collection.liquid, A83): un enlace
   * viejo con ?page=2 o más caería en una página vacía, así que se lleva a la primera.
   */
  (function () {
    var u = new URL(window.location.href);
    var pagina = u.searchParams.get('page');
    if (!/\/collections\//.test(u.pathname) || !pagina || pagina === '1') return;
    var conTalla = false;
    u.searchParams.forEach(function (valor, clave) {
      if (/^filter\.v\.option\.(talla|size)/i.test(clave)) conTalla = true;
    });
    if (!conTalla) return;
    u.searchParams.delete('page');
    window.location.replace(u.toString());
  })();

  /* Menú móvil (snippets/bc-nav-movil.liquid): los desplegables <details> se cierran al tocar fuera */
  document.addEventListener('click', function (evento) {
    document.querySelectorAll('.bc-nav-movil details[open]').forEach(function (d) {
      if (!d.contains(evento.target)) d.removeAttribute('open');
    });
  });

  /* ------------------------------------------------------------------ 5 · Aviso al agregar al carrito
   * Palo Alto abre el cajón del carrito después de cada «Agregar». En su lugar se muestra una cajita sobria
   * con la pieza (miniatura, nombre, talla) y dos botones: «Ver carrito» (abre el cajón) y «Finalizar
   * compra». Se cierra sola a los 6 s, con la X o con Esc. La cuenta se pausa solo si el mouse SE MUEVE dentro
   * de la caja o si recibe el foco (un cursor que quedó encima al aparecer no la pausa). Durante 400 ms después
   * de aparecer, la caja no recibe clics: un doble clic en «Agregar» no cae en «Finalizar compra».
   * En escritorio va abajo a la izquierda, fuera de la columna de compra (assets/bc.css).
   * Mecánica: al pedir /cart/add se guarda la pieza; cuando el theme avisa «theme:cart:added» (justo antes
   * de abrir el cajón) se oculta el cajón sin animación, se cierra y aparece el aviso. Si el cajón ya estaba
   * abierto (p. ej. «Completa el look» dentro del carrito), no se interrumpe.
   */
  var aviso = (function () {
    var textos = window.bcTextos || {};
    var caja = null, tCerrar = null, pendiente = null;

    function cajon() { return document.querySelector('cart-items[data-cart-drawer]'); }

    function nodo(tag, clase, texto) {
      var n = document.createElement(tag);
      if (clase) n.className = clase;
      if (texto) n.textContent = texto;
      return n;
    }

    function crear() {
      caja = nodo('div', 'bc-aviso');
      caja.setAttribute('role', 'status');
      caja.setAttribute('aria-live', 'polite');
      caja.hidden = true;
      var cerrar = nodo('button', 'bc-aviso__cerrar', '\u00D7');
      cerrar.type = 'button';
      cerrar.setAttribute('aria-label', textos.cerrar || 'Cerrar');
      var pieza = nodo('div', 'bc-aviso__pieza');
      var img = nodo('img');
      img.alt = '';
      img.width = 60;
      img.height = 90;
      var info = nodo('div');
      info.appendChild(nodo('p', 'bc-aviso__nombre'));
      info.appendChild(nodo('p', 'bc-aviso__detalle'));
      pieza.appendChild(img);
      pieza.appendChild(info);
      var ver = nodo('button', 'bc-aviso__boton', textos.verCarrito || 'Ver carrito');
      ver.type = 'button';
      var pagar = nodo('a', 'bc-aviso__boton bc-aviso__boton--primario', textos.finalizar || 'Finalizar compra');
      pagar.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'checkout';
      [cerrar, nodo('p', 'bc-aviso__titulo', textos.agregado || 'Agregado al carrito'), pieza, ver, pagar]
        .forEach(function (n) { caja.appendChild(n); });
      document.body.appendChild(caja);

      cerrar.addEventListener('click', ocultar);
      ver.addEventListener('click', function () {
        ocultar();
        var c = cajon();
        if (c && typeof c.openCartDrawer === 'function') c.openCartDrawer();
      });
      caja.addEventListener('mousemove', function () { if (!caja.classList.contains('is-bloqueada')) clearTimeout(tCerrar); });
      caja.addEventListener('mouseleave', programar);
      caja.addEventListener('focusin', function () { clearTimeout(tCerrar); });
      caja.addEventListener('focusout', programar);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && caja && !caja.hidden) ocultar();
      });
    }

    function programar() { clearTimeout(tCerrar); tCerrar = setTimeout(ocultar, 6000); }

    function ocultar() {
      clearTimeout(tCerrar);
      if (!caja) return;
      caja.classList.remove('is-visible');
      caja.hidden = true;
    }

    function mostrar(item) {
      if (!caja) crear();
      var img = caja.querySelector('img');
      if (item.image) {
        img.src = item.image + (item.image.indexOf('?') === -1 ? '?' : '&') + 'width=120';
        img.hidden = false;
      } else {
        img.hidden = true;
      }
      caja.querySelector('.bc-aviso__nombre').textContent = item.product_title || item.title || '';
      var opciones = (item.options_with_values || [])
        .filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return o.name + ': ' + o.value; });
      caja.querySelector('.bc-aviso__detalle').textContent = opciones.join(' · ');
      // Móvil (A81): el aviso va arriba, justo bajo el borde real de la cabecera; la fila de navegación móvil
      // (.bc-nav-movil) sobresale de ella y es más alta que --header-sticky-height. En escritorio manda el CSS (abajo a la izquierda).
      var borde = 0;
      document.querySelectorAll('[data-site-header], .bc-nav-movil').forEach(function (el) {
        if (el.getClientRects().length) borde = Math.max(borde, el.getBoundingClientRect().bottom);
      });
      caja.style.top = window.matchMedia('(max-width: 767px)').matches ? Math.round(borde + 8) + 'px' : '';
      caja.hidden = false;
      caja.classList.add('is-bloqueada');
      setTimeout(function () { caja.classList.remove('is-bloqueada'); }, 400);
      requestAnimationFrame(function () { caja.classList.add('is-visible'); });
      programar();
    }

    document.addEventListener('theme:cart:added', function () {
      if (!pendiente) return;
      var item = pendiente;
      pendiente = null;
      document.documentElement.classList.add('bc-sin-cajon');
      setTimeout(function () {
        var c = cajon();
        if (c && typeof c.closeCartDrawer === 'function') c.closeCartDrawer();
        mostrar(item);
        setTimeout(function () { document.documentElement.classList.remove('bc-sin-cajon'); }, 600);
      }, 60); // después del bloqueo de scroll del theme (que corre en setTimeout 0), para que el desbloqueo gane
    });

    function esAgregar(url) { return !!url && /\/cart\/add(\.js)?$/.test(url.pathname); }

    function registrar(promesa) {
      var c = cajon();
      if (!c || c.classList.contains('is-open')) return;
      promesa.then(function (r) { return r.clone().json(); }).then(function (datos) {
        if (!datos || datos.status) return; // error: el theme muestra su propio mensaje
        pendiente = datos.items ? datos.items[datos.items.length - 1] : datos;
      }).catch(function () { pendiente = null; });
    }

    return { esAgregar: esAgregar, registrar: registrar };
  })();

  /* ------------------------------------------------------------------ 6 · Carrusel BC (snippets/bc-carrusel.liquid)
   * La pista es un scroll horizontal con «snap» (en táctil se desliza sola). Aquí se agregan las flechas
   * (avanzan lo que se ve entero), el arrastre con el mouse (un arrastre no dispara el clic de la tarjeta)
   * y la barra de avance. En modo infinito se clonan las tarjetas a los dos lados (aria-hidden, sin foco:
   * cada prenda se recorre una sola vez con teclado o lector) y, cuando el scroll se detiene lejos del
   * juego real, se salta sin animación exactamente un juego completo: el salto no se ve.
   * Además, la sección «momento» entra con un fade-up (nada si se pide menos movimiento o en el editor).
   */
  (function () {
    var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function suave() { return quieto ? 'auto' : 'smooth'; }

    function montar(pista) {
      if (pista.dataset.bcMontado) return;
      pista.dataset.bcMontado = '1';
      var caja = pista.closest('[data-bc-carrusel-raiz]') || pista.parentNode;
      var ant = caja.querySelector('[data-bc-carrusel-anterior]');
      var sig = caja.querySelector('[data-bc-carrusel-siguiente]');
      var avance = caja.querySelector('[data-bc-carrusel-avance]');
      var reales = Array.prototype.slice.call(pista.children);
      var infinito = caja.hasAttribute('data-bc-infinito') && reales.length > 1;
      var arrastrando = false;

      function paso() {
        var primera = reales[0] || pista.firstElementChild;
        var gap = parseFloat(getComputedStyle(pista).columnGap) || 0;
        return primera ? primera.getBoundingClientRect().width + gap : pista.clientWidth;
      }
      // scrollLeft que deja una tarjeta alineada (respeta el scroll-padding del infinito)
      function alinearA(el) {
        var margen = parseFloat(getComputedStyle(pista).scrollPaddingLeft) || 0;
        return pista.scrollLeft + el.getBoundingClientRect().left - pista.getBoundingClientRect().left - margen;
      }
      function masCercana() {
        var mejor = pista.scrollLeft, d = Infinity;
        Array.prototype.forEach.call(pista.children, function (el) {
          var x = alinearA(el), dx = Math.abs(x - pista.scrollLeft);
          if (dx < d) { d = dx; mejor = x; }
        });
        return mejor;
      }

      /* ---- Bucle (solo en modo infinito) */
      function clonar() {
        var juego = document.createDocumentFragment();
        reales.forEach(function (n) {
          var c = n.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.setAttribute('data-bc-clon', '');
          c.removeAttribute('id');
          c.querySelectorAll('[id]').forEach(function (e) { e.removeAttribute('id'); });
          c.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (e) { e.setAttribute('tabindex', '-1'); });
          juego.appendChild(c);
        });
        return juego;
      }
      function normalizar() {
        if (!infinito || arrastrando) return;
        var w = paso() * reales.length;           // ancho de un juego completo
        if (!w) return;
        var desvio = pista.scrollLeft - alinearA(reales[0]);
        if (desvio < -w / 2 || desvio >= w / 2) {
          pista.scrollTo({ left: pista.scrollLeft - Math.round(desvio / w) * w, behavior: 'instant' });
        }
      }
      if (infinito) {
        var w0 = paso() * reales.length || 1;
        var copias = Math.max(1, Math.ceil(Math.max(window.screen ? window.screen.width : 0, pista.clientWidth) / w0));
        for (var i = 0; i < copias; i++) {
          pista.insertBefore(clonar(), pista.firstChild);
          pista.appendChild(clonar());
        }
        pista.scrollTo({ left: alinearA(reales[0]), behavior: 'instant' });
        var tFin = null;
        if ('onscrollend' in window) pista.addEventListener('scrollend', normalizar);
        else pista.addEventListener('scroll', function () { clearTimeout(tFin); tFin = setTimeout(normalizar, 140); }, { passive: true });
        // Red de seguridad: si algo deja la pista al borde (p. ej. un cambio de tamaño), se recoloca antes de usarla
        caja.addEventListener('pointerenter', normalizar);
        caja.addEventListener('focusin', normalizar);
        if ('ResizeObserver' in window) new ResizeObserver(function () { normalizar(); }).observe(pista);
      }

      function estado() {
        if (infinito) {
          if (ant) ant.disabled = false;
          if (sig) sig.disabled = false;
          return;
        }
        var max = pista.scrollWidth - pista.clientWidth - 2;
        var alInicio = pista.scrollLeft <= 2;
        var alFinal = pista.scrollLeft >= max;
        // Si la flecha que se apaga tenía el foco, el foco pasa a la otra (no se pierde en <body>)
        if (sig && alFinal && document.activeElement === sig && ant && !alInicio) ant.focus();
        if (ant && alInicio && document.activeElement === ant && sig && !alFinal) sig.focus();
        if (ant) ant.disabled = alInicio;
        if (sig) sig.disabled = alFinal;
        // Al final la flecha queda apagada pero visible (assets/bc.css); si todo cabe, no hay flechas
        caja.classList.toggle('bc-carrusel--sin-recorrido', max <= 0);
        // La barra de avance solo cuando hay más piezas de las que caben
        if (avance) {
          avance.parentNode.hidden = max <= 0;
          var ancho = pista.scrollWidth ? pista.clientWidth / pista.scrollWidth : 1;
          var hueco = Math.max(pista.scrollWidth - pista.clientWidth, 1);
          var hecho = Math.min(Math.max(pista.scrollLeft / hueco, 0), 1);
          avance.style.width = (Math.min(ancho, 1) * 100) + '%';
          avance.style.transform = 'translateX(' + (hecho * (1 / Math.min(ancho, 1) - 1) * 100) + '%)';
        }
      }
      // Avanza lo que se ve entero (3 tarjetas en el momento en escritorio, 2 en tableta, 1 en móvil)
      function mover(dir) {
        normalizar();
        var p = paso();
        var visible = infinito ? caja.clientWidth : pista.clientWidth;
        var n = Math.max(1, Math.floor((visible + 1) / p));
        pista.scrollTo({ left: masCercana() + dir * n * p, behavior: suave() });
      }
      if (ant) ant.addEventListener('click', function () { mover(-1); });
      if (sig) sig.addEventListener('click', function () { mover(1); });
      pista.addEventListener('scroll', estado, { passive: true });
      window.addEventListener('resize', estado);
      pista.addEventListener('keydown', function (e) {
        if (e.target !== pista) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); mover(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); mover(-1); }
      });

      var x0 = 0, s0 = 0, movido = false;
      pista.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        arrastrando = true; movido = false; x0 = e.clientX; s0 = pista.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!arrastrando) return;
        var dx = e.clientX - x0;
        if (!movido && Math.abs(dx) < 6) return;
        if (!movido) { movido = true; pista.classList.add('is-arrastrando'); }
        pista.scrollLeft = s0 - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!arrastrando) return;
        arrastrando = false;
        if (!movido) return;
        var destino = masCercana();
        pista.classList.remove('is-arrastrando');
        pista.scrollTo({ left: destino, behavior: suave() });
      });
      pista.addEventListener('click', function (e) {
        if (movido) { e.preventDefault(); e.stopPropagation(); movido = false; }
      }, true);
      pista.addEventListener('dragstart', function (e) { e.preventDefault(); });
      estado();
    }

    function aparecer(seccion) {
      if (seccion.dataset.bcAparece || quieto || window.Shopify && window.Shopify.designMode || !('IntersectionObserver' in window)) return;
      seccion.dataset.bcAparece = '1';
      seccion.classList.add('bc-anima');
      var io = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          seccion.classList.add('is-visible');
          io.disconnect();
        });
      }, { threshold: 0.15 });
      io.observe(seccion);
    }
    function iniciar(raiz) {
      (raiz || document).querySelectorAll('[data-bc-carrusel]').forEach(montar);
      (raiz || document).querySelectorAll('[data-bc-momento]').forEach(aparecer);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(); });
    else iniciar();
    document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  })();

  /* ------------------------------------------------------------------ 7 · Zona outlet / web (A80)
   * El outlet es una tienda aparte. Cada tarjeta dice si es del outlet o de la web (data-bc-pieza,
   * snippets/product-grid-item.liquid) y la página dice en qué zona está (<html data-bc-zona="outlet">,
   * snippets/bc-head.liquid). «También te puede gustar» y «Vistos recientemente» llegan por JS y no saben
   * desde qué página se pidieron: aquí se quitan las piezas de la otra zona y, en recomendados, se deja
   * como máximo data-bc-limite. Una pestaña sin piezas se oculta (y su enlace); si quedan vacías todas,
   * la sección entera. El carrito vacío del outlet se resuelve en CSS (assets/bc.css, «Carrito vacío»).
   */
  (function () {
    var zona = document.documentElement.getAttribute('data-bc-zona') === 'outlet' ? 'outlet' : 'web';

    function podar(seccion) {
      seccion.querySelectorAll('[data-bc-pieza]').forEach(function (el) {
        if (el.getAttribute('data-bc-pieza') !== zona) el.remove();
      });
      seccion.querySelectorAll('[data-bc-limite]').forEach(function (lista) {
        var max = parseInt(lista.getAttribute('data-bc-limite'), 10);
        if (!max) return;
        Array.prototype.slice.call(lista.querySelectorAll('[data-bc-pieza]'), max).forEach(function (el) { el.remove(); });
      });

      var tabs = seccion.querySelectorAll('[data-tab]');
      if (!tabs.length) return;
      var llenas = [];
      tabs.forEach(function (tab) {
        var llena = !!tab.querySelector('[data-bc-pieza]');
        tab.hidden = !llena;
        var enlace = seccion.querySelector('[data-tabs-link="' + tab.getAttribute('data-tab') + '"]');
        if (enlace) enlace.hidden = !llena;
        if (llena) llenas.push(tab);
      });
      seccion.hidden = llenas.length === 0;
      // Si la pestaña abierta quedó vacía (p. ej. los recomendados aún no llegan), se abre la primera con
      // piezas; cuando la original se llena, se vuelve a ella (la clienta no tocó nada).
      var actual = seccion.querySelector('[data-tabs-link].current');
      var preferida = seccion.dataset.bcPestana && seccion.querySelector('[data-tabs-link="' + seccion.dataset.bcPestana + '"]');
      if (preferida && !preferida.hidden && preferida !== actual) {
        delete seccion.dataset.bcPestana;
        preferida.click();
      } else if (actual && actual.hidden && llenas.length) {
        var otra = seccion.querySelector('[data-tabs-link="' + llenas[0].getAttribute('data-tab') + '"]');
        if (otra) {
          if (!seccion.dataset.bcPestana) seccion.dataset.bcPestana = actual.getAttribute('data-tabs-link');
          otra.click();
        }
      }
    }

    function vigilar(seccion) {
      if (seccion.dataset.bcZonaVigilada) return;
      seccion.dataset.bcZonaVigilada = '1';
      var pendiente = false;
      new MutationObserver(function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () { pendiente = false; podar(seccion); });
      }).observe(seccion, { childList: true, subtree: true });
      podar(seccion);
    }

    function iniciar(raiz) {
      (raiz || document).querySelectorAll('related-products, recently-viewed').forEach(vigilar);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(); });
    else iniciar();
    document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
  })();

  /* ------------------------------------------------------------------ 8 · Talla sin elegir (A71)
   * La ficha abre sin talla marcada (snippets/product-form.liquid, data-bc-talla). Si la clienta toca
   * «Agregar al carrito» sin elegirla, no se agrega nada: sale «Elige tu talla» bajo el título de la
   * talla y el foco va a la primera talla. Se intercepta en captura, antes que Palo Alto (el envío del
   * formulario y el botón de agregar rápido). Al elegir una talla el aviso se va.
   */
  (function () {
    function tallaSinElegir(form) {
      var campos = document.querySelectorAll('[data-bc-talla]');
      for (var i = 0; i < campos.length; i++) {
        var entradas = Array.prototype.filter.call(campos[i].querySelectorAll('input[type="radio"]'), function (el) { return el.form === form; });
        if (entradas.length && !entradas.some(function (el) { return el.checked; })) return campos[i];
      }
      return null;
    }

    function avisar(campo) {
      campo.classList.add('bc-talla--falta');
      var aviso = campo.querySelector('[data-bc-talla-aviso]');
      if (!aviso) {
        aviso = document.createElement('p');
        aviso.className = 'bc-talla-aviso';
        aviso.setAttribute('data-bc-talla-aviso', '');
        aviso.setAttribute('role', 'alert');
        aviso.textContent = campo.getAttribute('data-bc-talla-texto') || 'Elige tu talla';
        var leyenda = campo.querySelector('legend');
        if (leyenda) leyenda.insertAdjacentElement('afterend', aviso);
        else campo.prepend(aviso);
      }
      var caja = campo.getBoundingClientRect();
      if (caja.top < 80 || caja.bottom > window.innerHeight) campo.scrollIntoView({ block: 'center', behavior: 'smooth' });
      var primera = campo.querySelector('input[type="radio"]:not([aria-disabled="true"])') || campo.querySelector('input[type="radio"]');
      if (primera) primera.focus({ preventScroll: true });
    }

    function frenar(evento, form) {
      if (!form) return;
      var campo = tallaSinElegir(form);
      if (!campo) return;
      evento.preventDefault();
      evento.stopImmediatePropagation();
      avisar(campo);
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.matches && form.matches('form[action*="/cart/add"]')) frenar(e, form);
    }, true);
    document.addEventListener('click', function (e) {
      var boton = e.target.closest && e.target.closest('[data-add-to-cart], product-form [type="submit"]');
      if (!boton) return;
      var form = boton.form || (boton.closest('product-form') && boton.closest('product-form').querySelector('form'));
      frenar(e, form);
    }, true);
    document.addEventListener('change', function (e) {
      var campo = e.target.closest && e.target.closest('[data-bc-talla]');
      if (!campo) return;
      campo.classList.remove('bc-talla--falta');
      var aviso = campo.querySelector('[data-bc-talla-aviso]');
      if (aviso) aviso.remove();
    });
  })();

  /* ------------------------------------------------------------------ 9 · Póster de los videos de fondo (A83)
   * Debajo de cada video de fondo va su foto (<img> con srcset, snippets/video.liquid). El <video> la usaba
   * además como poster en 1920 px: la misma foto se bajaba dos veces (en móvil, 1296 px + 1920 px). Palo Alto
   * inserta el <video> desde un <template>; en cuanto aparece se le pone como poster la foto que el <img> ya
   * eligió (currentSrc, que sale de la caché). Si esa foto aún no cargó (la de un video más abajo, en diferido),
   * el video queda sin poster y se ve la foto de debajo cuando llegue. El observador corre antes del pintado.
   */
  (function () {
    function ponerPoster(video) {
      if (!video.hasAttribute('data-bc-poster') || video.getAttribute('poster')) return;
      var contenedor = video.closest('.video__container');
      var img = contenedor && contenedor.querySelector('img');
      var src = img && img.currentSrc;
      if (src) video.setAttribute('poster', src);
    }
    function revisar(raiz) {
      (raiz || document).querySelectorAll('video[data-bc-poster]').forEach(ponerPoster);
    }
    function vigilar() {
      document.querySelectorAll('[data-video-player]').forEach(function (reproductor) {
        if (reproductor.dataset.bcPoster) return;
        reproductor.dataset.bcPoster = '1';
        new MutationObserver(function () { revisar(reproductor); }).observe(reproductor, { childList: true, subtree: true });
      });
      revisar();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vigilar);
    else vigilar();
    document.addEventListener('shopify:section:load', vigilar);
  })();

  /* ------------------------------------------------------------------ 10 · Tope de cantidad en el carrito (A83)
   * El campo de cantidad lleva max = unidades en stock (snippets/cart-line-items.liquid); Palo Alto apaga el
   * «+» al llegar (clase is-disabled) pero no dice por qué. Sin el tope, el «+» pedía de más y Shopify respondía 422.
   * Un toque al «+» apagado muestra el aviso del propio theme en el cajón o en /cart («No tenemos más unidades
   * de esta pieza en esa talla.» + la pieza, [data-cart-errors]) y no pide nada al servidor. Si el stock cambió
   * entre tanto y /cart/change responde 422, el theme ya muestra ese mismo aviso por su cuenta.
   */
  (function () {
    function avisar(linea) {
      var carro = linea && linea.closest('cart-items');
      var caja = carro && carro.querySelector('[data-cart-errors]');
      if (!caja) return;
      var texto = caja.querySelector('[data-error-message]');
      caja.classList.add('is-expanded');
      if (texto) texto.textContent = linea.getAttribute('data-item-title') || '';
      var r = caja.getBoundingClientRect();
      if (r.top < 0 || r.bottom > window.innerHeight) caja.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    document.addEventListener('click', function (e) {
      var mas = e.target.closest && e.target.closest('.cart__item__quantity-plus.is-disabled');
      if (!mas) return;
      e.preventDefault();
      e.stopPropagation();   // en captura: el «+» de Palo Alto no llega a pedir nada
      avisar(mas.closest('[data-cart-item]'));
    }, true);
  })();

  /* ------------------------------------------------------------------ Único envoltorio de fetch */
  var fetchOriginal = window.fetch;
  if (!fetchOriginal) return;
  window.fetch = function (recurso, opciones) {
    var url = aUrl(recurso);
    recurso = busqueda.reescribir(recurso, url);
    var accion = loader.esAccion(url);
    var gen = accion ? loader.empezar() : null;
    var promesa = fetchOriginal.call(this, recurso, opciones);
    if (accion) promesa.then(function () { loader.terminar(gen); }, function () { loader.terminar(gen); });
    if (carrito.esCambio(url)) promesa.then(carrito.actualizar, carrito.actualizar);
    if (aviso.esAgregar(url)) aviso.registrar(promesa);
    return promesa;
  };
})();
